"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetByIdGroupedLiveClass = void 0;
const interfaces_1 = require("@build-5/interfaces");
const lodash_1 = require("lodash");
const rxjs_1 = require("rxjs");
const fetch_utils_1 = require("../fetch.utils");
const common_1 = require("./common");
const observable_1 = require("./observable");
class GetByIdGroupedLiveClass extends common_1.AbstractGetByIdGrouped {
    constructor() {
        super(...arguments);
        this.observers = {};
        this.get = async (request) => {
            this.init(request);
            if (this.requests.length >= common_1.BATCH_MAX_SIZE) {
                await this.executeRequests();
                return this.observers[request.setId + request.subsetId];
            }
            await this.executeTimed();
            return this.observers[request.setId + request.subsetId];
        };
        this.executeRequests = async () => {
            const promises = this.createUrl().map(async ({ requests, url, params }) => {
                try {
                    const apiKey = requests[0].apiKey;
                    const source = (0, observable_1.fetchLive)(apiKey, url + (0, fetch_utils_1.toQueryParams)(params)).pipe((0, rxjs_1.map)((r) => (Array.isArray(r) ? r : [r])));
                    for (const r of requests) {
                        this.observers[r.setId + r.subsetId] = source.pipe((0, rxjs_1.map)((s) => {
                            const id = r.subsetId || r.setId;
                            return s.find((d) => [(0, lodash_1.get)(d, 'uid', ''), (0, lodash_1.get)(d, 'id', '')].includes(id));
                        }));
                    }
                    return [];
                }
                catch (_a) {
                    await new Promise((resolve) => setTimeout(resolve, interfaces_1.API_RETRY_TIMEOUT));
                    return requests;
                }
            });
            this.requests.push(...(0, lodash_1.flatten)(await Promise.all(promises)));
        };
    }
}
exports.GetByIdGroupedLiveClass = GetByIdGroupedLiveClass;
const GetByIdGroupedLive = new GetByIdGroupedLiveClass();
exports.default = GetByIdGroupedLive;
